import { css } from '@emotion/react'
import Bowser from 'bowser'
import { motion } from 'motion/react'
import JikeLogo from './Icons/JikeLogo'
import Page, { type PageProps } from './Page'

export interface UnsupportedBrowserPageProps extends PageProps {}

export default function UnsupportedBrowserPage({ ...props }: UnsupportedBrowserPageProps) {
	const browserInfo = Bowser.getParser(window.navigator.userAgent)
	const { name, version } = browserInfo.getBrowser()

	return (
		<Page {...props}>
			<div
				css={css`
					height: 100vh;
					display: flex;
					flex-direction: column;
					justify-content: center;
				`}
			>
				<JikeLogo
					css={css`
						flex-shrink: 0;
						width: 128px;
						height: 128px;
						margin: 0 auto;
						display: block;
					`}
				/>

				<h1
					css={css`
						text-align: center;
					`}
				>
					请使用新版浏览器
				</h1>

				<p
					css={css`
						text-align: center;
						line-height: 24px;
					`}
				>
					为获得最佳用户体验，推荐使用以下浏览器的最新版本
					<br />
					（当前浏览器：{name} v{version}）
				</p>

				<ul
					css={css`
						margin: 64px auto 0;
						display: flex;
						align-items: center;
						gap: 16px;
						list-style: none;

						.browser-item {
							display: flex;
							align-items: center;
							gap: 8px;

							font-size: 16px;
							color: var(--tint-secondary);

							img {
								width: 36px;
								aspect-ratio: 1;
								cursor: pointer;
								border-radius: 50%;
							}
						}
					`}
				>
					<li>
						<motion.a
							href="https://www.apple.com/safari/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className="browser-item"
						>
							<img src="/safari.svg" />
							<span css={css``}>v{import.meta.env.VITE_SUPPORTED_MIN_SAFARI_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.google.com/chrome/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className="browser-item"
						>
							<img src="/chrome.svg" />
							<span css={css``}>v{import.meta.env.VITE_SUPPORTED_MIN_CHROME_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://download-chromium.appspot.com/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className="browser-item"
						>
							<img src="/chromium.svg" />
							<span css={css``}>v{import.meta.env.VITE_SUPPORTED_MIN_CHROME_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.mozilla.org/en-US/firefox/new/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className="browser-item"
						>
							<img src="/firefox.svg" />
							<span css={css``}>v{import.meta.env.VITE_SUPPORTED_MIN_FIREFOX_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.microsoft.com/en-us/edge/download"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className="browser-item"
						>
							<img src="/edge.svg" />
							<span css={css``}>v{import.meta.env.VITE_SUPPORTED_MIN_EDGE_VERSION}+</span>
						</motion.a>
					</li>
				</ul>
			</div>
		</Page>
	)
}
